import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { expenseTypesService } from "services";
import { FiPlus, FiMoreHorizontal, FiSearch } from "react-icons/fi";
import { Dropdown, FormGroup, FormControl } from "react-bootstrap";
import Layout from "components/Layout";
import Loading from "components/Loading";
import ExpenseTypeEdit from "components/ExpenseTypes/ExpenseTypeEditModal";
import Modal from "components/Modal";
import DataTable from "components/DataTable/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as expensesActions from "actions/expensesActions";
import { errorFormating } from "utils/utils";

class ExpenseTypes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchExpenseType: "",
		};

		this.closeModal = this.closeModal.bind(this);
		this.openNewExpenseTypeModal = this.openNewExpenseTypeModal.bind(this);
		this.openEditExpenseTypeModal = this.openEditExpenseTypeModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getExpenseTypes = this.getExpenseTypes.bind(this);
	}

	componentDidMount() {
		this.getExpenseTypes();
	}

	handleChangeSearch = (event) => {
		this.setState({ [event.target.id]: event.target.value }, () => {
			this.getExpenseTypes();
		});
	};

	async getExpenseTypes() {
		await this.props.getAllExpenseTypes({ q: this.state.searchExpenseType });
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewExpenseTypeModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenses.newCategory"),
				style: { width: "400px" },
				content: (
					<ExpenseTypeEdit
						getExpenseTypes={this.getExpenseTypes}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditExpenseTypeModal(expense_type) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenses.editCategory"),
				style: { width: "400px" },
				content: (
					<ExpenseTypeEdit
						expense_type={expense_type}
						getExpenseTypes={this.getExpenseTypes}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteExpenseTypeModal(idExpenseType) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenses.deleteCategory"),
				style: { width: "400px" },
				message: t("expenses.deleteCategoryConfirm"),
				deleteAction: () => this.confirmDelete(idExpenseType),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("expenses.errorDelete"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idExpenseType) => {
		const response = await expenseTypesService.remove(idExpenseType);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.getExpenseTypes();
			this.closeModal();
		}
	};

	getColumns = () => {
		const { t } = this.props;
		return [
		{
			key: "name",
			header: t("expenses.columns.name"),
			render: (expense_type) => (
				<button
					className="btn-transparent btn-editable"
					onClick={() => this.openEditExpenseTypeModal(expense_type)}
				>
					{expense_type.name}
				</button>
			),
		},
		{
			key: "description",
			header: t("expenses.columns.description"),
		},
		{
			key: "max_value",
			header: "Límite (€)",
			render: (expense_type) =>
				expense_type.max_value ? `${expense_type.max_value} €` : "—",
		},
		{
			key: "enabled",
			header: t("expenses.columns.enabled"),
			render: (expense_type) =>
				expense_type.enabled ? (
					<span title={t("common.active")} className="estado estado-si">
						{t("common.active")}
					</span>
				) : (
					<span title={t("common.inactive")} className="estado estado-no">
						{t("common.inactive")}
					</span>
				),
		},
		{
			key: "color",
			header: "",
			sortable: false,
			cellClassName: "td-icon",
			render: (expense_type) => (
				<span
					className="bolita"
					style={{
						backgroundColor: expense_type.background_color || undefined,
						border: expense_type.border_color
							? `2px solid ${expense_type.border_color}`
							: undefined,
					}}
				/>
			),
		},
	];
	};

	getContent = () => {

		if (this.props.loading) {
			return <Loading />;
		}

		if (this.props.error) {
<div className="no-results">{this.props.t("expenses.errorLoadingCategories")}</div>
		}

		return (
			<DataTable
				tableClassName="table-categories table-hover"
				columns={this.getColumns()}
				rows={this.props.expense_types}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t("expenses.noCategoriesYet")}
				actionsColumn={{
					render: (expense_type) => (
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() => this.openEditExpenseTypeModal(expense_type)}
								>
									{this.props.t("common.edit")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() =>
										this.openDeleteExpenseTypeModal(expense_type.id)
									}
								>
									{this.props.t("common.delete")}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					),
					className: "td-actions",
				}}
			/>
		);
	};

	render() {
		return (
			<>
				<Layout
					className="page-categories"
					context="expenses"
					configSidebar={true}
				>
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{this.props.t("expenses.categoriesTitle")}</h1>
						</div>
						<div className="heading-filters">
							<FormGroup
								className="form-group form-search"
								controlId="searchExpenseType"
							>
								<FormControl
									type="text"
									placeholder={this.props.t("common.searchPlaceholder")}
									value={this.state.searchExpenseType}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t("expenses.createCategory")}
								onClick={this.openNewExpenseTypeModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.expensesReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllExpenseTypes: (options) =>
		dispatch(expensesActions.getAllExpenseTypes(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ExpenseTypes));
